import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
const transferOrderApi = factory.get("transferOrder");

const emptyItem = {
  product_id: null,
  quantity: 1,
  serial_numbers: [],
};

const initialState = {
  searchBody: {},
  transferOrder: {
    loading: false,
    dialog: false,
    form: {
      from_user_id: null,
      to_user_id: null,
      note: "",
      items: [emptyItem],
    },
  },
  details: {
    loading: false,
    dialog: false,
    data: null,
  },
  transferOrders: {
    loading: false,
    data: [],
    total: 0,
  },
};

export const transferOrderSlice = createSlice({
  name: "transferOrder",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.transferOrder.dialog = !state.transferOrder.dialog;
    },
    setDetailsDialog: (state, { payload }) => {
      state.details.dialog = !state.details.dialog;
      state.details.data = payload ?? null;
    },
    setDataTable: (state, { payload }) => {
      state.transferOrders.data = payload.data.data;
      state.transferOrders.total = payload.data.total;
    },
    setLoading: (state, action) => {
      state.transferOrders.loading = !state.transferOrders.loading;
    },
    setDetailsLoading: (state, action) => {
      state.details.loading = !state.details.loading;
    },
    resetForm: (state, action) => {
      state.transferOrder.form = initialState.transferOrder.form;
    },
    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
  },
});

export const {
  setLoading,
  setDetailsLoading,
  setDialog,
  setDetailsDialog,
  setDataTable,
  resetForm,
  setSearchBody,
} = transferOrderSlice.actions;

export default transferOrderSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await transferOrderApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading());
  } catch (err) {
    dispatch(setLoading());
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getById = (id) => async (dispatch) => {
  try {
    dispatch(setDetailsLoading());
    const res = await transferOrderApi.getById(id);
    dispatch(setDetailsDialog(res.data.data[0]));
    dispatch(setDetailsLoading());
  } catch (err) {
    dispatch(setDetailsLoading());
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const create = (data, _SearchBody) => async (dispatch) => {
  try {
    await transferOrderApi.create(data);
    dispatch(
      showNotification({
        message: "تمت الاضافة بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const TransferOrder = {
  getAll,
  getById,
  create,
};
